export default "__VITE_ASSET__eebbb211__"